import {LinkedDocumentModel} from "./linked-document-model";
import {Localizable} from 'projects/borrower-app/src/app/transloco/localize-field';

export class ApplicationTaskModel implements Localizable {
  taskId: number = -1;
  taskTypeId: string | undefined;
  borrowerTaskType: BorrowerTaskType | undefined;
  description: string | undefined;
  docType: string | undefined;
  docSortOrder: number | undefined;
  submittedDate: Date | undefined;
  approvedDate: Date | undefined;
  dueDate: Date = new Date();
  templateDocumentUrl: string | undefined;
  borrowerId: number | undefined;
  borrowerName: string | undefined;
  borrowerFacingNote: string | undefined;
  /** LLS-886: lender-entered Spanish names from the Api ({ es: { docType, description } }). */
  _i18n?: Record<string, Record<string, string>>;
  borrowerTaskStatus: BorrowerTaskStatus | undefined;
  thirdPartyIntegrationProvider?: string | null;
  linkedDocuments: LinkedDocumentModel[] | undefined;
  allowUpload: boolean | undefined;
  isAgentTask: boolean | undefined;
  allowMarkNA: boolean | undefined;
  signingLinkSentInEmail: boolean | null;
  htmlWidgetSrc?: string | null;
  alwaysShowPending?: boolean | null;
  websiteUrl?: string | null;
  constructor() {
  }
}

export enum BorrowerTaskStatus {
  Pending = "Pending",
  Submitted = "Submitted",
  Rejected = "Rejected",
  Completed = "Completed",
  Approved = "Approved"
}

export enum BorrowerTaskType {
  RequestDocument = "RequestDocument",
  ViewDocument = "ViewDocument",
  AcknowledgeReceipt = "AcknowledgeReceipt",
  EsignDocument = "EsignDocument",
  RequestInformation = "RequestInformation",
  PerformAction = "PerformAction",
  OnlineApplication = "OnlineApplication",
  DigitalAssetVerification = "DigitalAssetVerification",
  DigitalIncomeEmploymentVerification = "DigitalIncomeEmploymentVerification",
  GenerateDocument = "GenerateDocument",
  RequestPayoff = "RequestPayoff",
  RequestHoi = "RequestHoi",
  MiQuote = "MiQuote",
  RequestTitle = "RequestTitle",
  RequestEscrow = "RequestEscrow",
  RequestAppraisal = "RequestAppraisal",
  LosEsign = "LosEsign",
  WetSignDocument = "WetSignDocument",
  LoanBeamSync = "LoanBeamSync",
  GatherPayment = "GatherPayment",
  ChangeOfCircumstance = "ChangeOfCircumstance",
  Escalation = "Escalation",
  WebsiteLink = "WebsiteLink",
  CreditAuthorization = "CreditAuthorization"
}
